import styled from 'styled-components';
import router from 'next/router';

import { useTranslation } from '@hooks';
import { ArrowBottomIcon } from '@components/icons';
import { H3, Subtitle2 } from '@components/styles/Typography';
import { NewButton } from '@components/ui';

const CartMobileMenu = ({
    handleOpen,
    total,
    forCheckout,
    pay,
    currentUser,
    isDisabled,
    hideButton,
}) => {
    const { t, useCurrency } = useTranslation();

    function goCheckout() {
        if (currentUser) {
            router.push('/checkout');
        } else {
            router.push({
                pathname: '/login',
                query: { cb: '/checkout' },
            });
        }
    }

    const handleClick = () => {
        if (forCheckout) {
            pay();
        } else {
            goCheckout();
        }
    };
    const buttonTitle = forCheckout ? 'cartConfirm' : 'pay';
    return (
        <MobileMenuWrapper>
            <MobileMenuModalOpen onClick={handleOpen}>
                <ArrowBottomIcon style={{ transform: 'rotate(180deg)' }} />
                <div>
                    <Subtitle2 color="bgGray50" uppercase>
                        {t('cartTotal')}
                    </Subtitle2>
                    <H3>{useCurrency(total)}</H3>
                </div>
            </MobileMenuModalOpen>
            {!hideButton && (
                <NewButton
                    type="primary"
                    size="large"
                    disabled={
                        (forCheckout && isDisabled) || Number(total?.TRY) === 0
                    }
                    content={t(buttonTitle)}
                    handleClick={handleClick}
                    data-testid="cart-mobile-button"
                />
            )}
        </MobileMenuWrapper>
    );
};

const MobileMenuWrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    align-items: center;
    height: 80px;
    background-color: ${({ theme }) => theme.colors.secondary};
    z-index: 99;
    border-top: ${({ theme }) => `1px solid ${theme.colors.bgGray10}`};

    @media (min-width: 1025px) {
        display: none;
    }
`;
const MobileMenuModalOpen = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    flex-direction: row !important;
    cursor: pointer;

    div {
        width: 50%;
        margin-left: 23px;
    }
`;
export default CartMobileMenu;
